import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
// import FormDialog from '../../../components/table/FormDialog';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
// import Select from '@material-ui/core/Select';
// import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import DataTable from './common/view/index';
// import DataTable from '../../../components/table/Table';
import SearchBox from '../../../components/table/SearchBox';
import FormDialog from './common/FormDialog';
import { CommonConfig } from '../../../config/common-config';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import './deleteEmpStyles.css';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    txtCenter: {
        justifyContent: 'center',
    },
    pointerEvents: {
        pointerEvents: 'none !important',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
}));
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function DeleteEmp(props) {
    const history = useHistory();
    // const [AllImcs, setAllImcs] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [pageDetails, setPageDetails] = useState('');
    const [page, setPage] = useState(0);
    const [previousButton, setpreviousButton] = useState(true);
    const [nextButton, setnextButton] = useState(true);
    // const [deletedata, setDeleteData] = useState(rows);
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [rows, setRows] = useState([]);
    const [coreTeamMemeber, setCoreTeamMember] = useState([]);
    const [selectedService, setSelectedService] = useState([]);
    // const [pageDetails, setPageDetails] = useState({});
    const [reRender, setReRender] = useState(false);
    const [deletedEmp, setDeletedEmp] = useState('');
    const [showConfirmDeleteDialoge, setShowConfirmDeleteDialoge] = useState(false);
    const [targetedDB, setTargetedDB] = useState('');
    // const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const vertical = 'top';
    const horizontal = 'center';
    // const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const invoiceId = rows.id;
    const [itecOpen, setItecOpen] = React.useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const handleRelevence = () => {
        setItecOpen(true);
    };
    const handelCloseDeleteAssigniPopUp = () => {
        setItecOpen(false);
    };
    // const [selectedImc, setselectedImc] = useState(dbname);
    const classes = useStyles();

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const location = useLocation();
    const noOfServices = location.state.row;

    const [isActive, setActive] = React.useState(false);

    const [loading, setLoading] = useState(true);


    ////console.log('noOfServices', noOfServices);
    //console.log("selectedImc", selectedImc);
    //console.log("usertype", usertype);

    const headCells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientName', label: 'Client Name' },
        { id: 'clientType', label: 'Client Type' },
        { id: 'description', label: 'Description' },
        { id: 'serviceType', label: 'Service Type' },
        // { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        // { id: 'dateAtThisStage', label: 'Date at this stage' },
        { id: 'currentStatus', label: 'Current Status' },
    ];

    // const { breadCrumbLabel, breadCrumbPath } = props;

    useEffect(() => {
        console.log("props:", props, page);
        setShowLoader(true);
        setDeletedEmp(props.location.state.row);
        setTargetedDB(props.location.state.tennantName);
        getEmployeeServices();
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${props.location.state.tennantName}?page=${page}&size=1000`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                // console.log("response-CoreTeam", response.data.content);
                setCoreTeamMember(response.data.content);
                setPageDetails(response.data);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((e) => {
                setShowLoader(false);
            });
    }, [bearerToken, reRender, page]);

    const getEmployeeServices = () => {
        axios
            // .get(`${CommonConfig.dev.baseUrl}/api/auth/getEmployeeServices/${props.location.state.tennantName}?page=${page}&size=10&sort=serviceId,desc/${noOfServices.empId}`, {
            .get(`${CommonConfig.dev.baseUrl}/api/auth/getEmployeeServices/${props.location.state.tennantName}/${noOfServices.empId}?page=${page}&size=10`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                // console.log('response-123',response.data.content);
                createDisplayJson(response.data.content);
                // console.log('response-12345',response.data.first);
                setPageDetails(response.data);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => { });
    }

    const createDisplayJson = (data) => {
        let rowData = [];
        for (let i = 0; i < data.length; i++) {
            const serviceJson = {
                serviceId: '',
                clientId: '',
                clientName: '',
                clientType: '',
                description: '',
                serviceType: '',
                // servicetypeId: '',
                serviceYear: '',
                startDate: '',
                // dateAtThisStage: '',
                currentStatus: '',
                isSelected: false,
            };
            serviceJson.serviceId = data[i].serviceId;
            serviceJson.clientId = data[i].clientId;
            serviceJson.clientName = data[i].clientName;
            serviceJson.clientType = data[i].clientType;
            serviceJson.description = data[i].description;
            // serviceJson.serviceType = data[i].serviceType;
            serviceJson.serviceType = data[i].servicetypeId.description;
            serviceJson.serviceYear = data[i].serviceYear;
            serviceJson.startDate = data[i].startDate;
            // serviceJson.dateAtThisStage = data[i].servicetypeId.dateModified;
            serviceJson.currentStatus = data[i].checkList.currentStage.stageDescription;
            // .statusId.description;
            rowData.push(serviceJson);
        }
        setRows(rowData);
        setShowLoader(false);
    }

    const handleClose = () => {
        setOpenBox(false);
    };

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const openDeleteEmployeDialoge = () => {
        setShowConfirmDeleteDialoge(true);
    };

    const handelCloseDeleteEmployeeDialoge = () => {
        setShowConfirmDeleteDialoge(false);
    };

    const checkItem = (row, flag) => {
        setActive(flag);
        if (row.isSelected) {
            selectedService.push(row);
        } else {
            let tempSelectedService = selectedService;
            let filterSelectedService = tempSelectedService.filter((item) => item.serviceId != row.serviceId);
            setSelectedService(filterSelectedService);
        }

    };

    const onAssignEmployee = (employeeList) => {
        console.log('aaaa',employeeList)
        // setShowLoader(true);
        let serviceIdList = [];
        selectedService.map((item) => {
            serviceIdList.push(item.serviceId);
        });
        let payload = {
            servicesIds: serviceIdList,
            assignees: employeeList,
        };
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/updateAssignee/${targetedDB}`, payload, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                console.log('assignAPICallresponse:', response);
                if (response.status === 200) {
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setSuccessPop(true);
                    }, 1000);
                    setTimeout(() => {
                        // setReRender(!reRender);
                        setSuccessPop(false);
                        axios
                            .get(`${CommonConfig.dev.baseUrl}/api/auth/getEmployeeServices/${props.location.state.tennantName}/${noOfServices.empId}?page=${page}&size=10`, {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            })
                            .then((response) => {
                                if (response && response.data && response.data.content && response.data.content.length > 0) {
                                    getEmployeeServices();
                                } else {
                                    history.push({
                                        pathname: '/menu/delete-core-employee',
                                        state: { itecEmpId: deletedEmp['empId'], tennantName: targetedDB },
                                    });
                                }
                            })
                            .catch((error) => { });
                    }, 3000);
                }
            });
    };

    const deleteEmployee = (deletedEmployee) => {
        ////console.log('final Delete employee Api Call', deletedEmployee);
        setShowLoader(true);
        axios
            .delete(`${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${targetedDB}/${deletedEmployee.empId}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                const { status } = response;
                if (status === 200) {
                    // loader need to implemented
                    setShowLoader(false);
                    history.push({
                        pathname: '/menu/CoreView',
                    });
                }
            })
            .catch((e) => {
                setShowLoader(false);
                // error msg need to be implemented
            });
    };

    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            return headCells
                .map((col) => col)
                .some((key) => {
                    if (key.isConcat && searchRow[key.id]) {
                        const subdata = searchRow[key.id];
                        const mergedData = key.concatElem.map((concatdata) => {
                            return concatdata.split('.').reduce((acc, item) => {
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }

                                return false;
                            }, subdata);
                        });
                        //console.log(mergedData,"mergeData");

                        return mergedData[0];
                    }
                    return searchRow[key.id].toString().toLowerCase().includes(query);
                });
        })
        : rows;
    return (
        <>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Service Assigned successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            {/* {rows.length > 0 ? ( */}
            <Card className="custom-table">
                <>
                    <div>
                        {/* <Grid container className="main-container field-container"></Grid> */}

                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Assign Pending Tasks</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                {/* {isActive ? */}
                                <div className="card-add-button">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        onClick={() => handleRelevence()}
                                        className={selectedService && selectedService.length ? classes.button : classes.pointerEvents}
                                    >
                                        Assign To Others
                                    </Button>
                                </div>
                                {/* : null} */}
                            </Grid>
                            {/* <FormDialog pageName="delete" /> */}
                        </CardContent>
                    </div>
                    <CardContent className="card-table-display">
                        {rows && filteredRow.length > 0 ? (
                            <DataTable
                                rows={filteredRow}
                                headCells={headCells}
                                pageName="core"
                                action={false}
                                checkBox={'true'}
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                checkItem={checkItem}
                                loading={loading}
                                // prvnxtbt={{ prvBt: true, nxtBt: true }}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}

                            />
                        ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                    </CardContent>
                </>
            </Card>
            {/* ):null } */}

            {itecOpen && (
                <FormDialog
                    itecOpen={itecOpen}
                    showConfirmDeleteDialoge={showConfirmDeleteDialoge}
                    coreTeamMember={coreTeamMemeber}
                    handelCloseDeleteAssigniPopUp={handelCloseDeleteAssigniPopUp}
                    onAssignEmployee={onAssignEmployee}
                    deletedEmp={deletedEmp}
                />
            )}

            {showConfirmDeleteDialoge && (
                <FormDialog
                    itecOpen={itecOpen}
                    showConfirmDeleteDialoge={showConfirmDeleteDialoge}
                    coreTeamMember={coreTeamMemeber}
                    handelCloseDeleteEmployeeDialoge={handelCloseDeleteEmployeeDialoge}
                    deleteEmployee={deleteEmployee}
                    deletedEmp={deletedEmp}
                />
            )}
        </>
    );
}
export default DeleteEmp;
